export class ResultWithoutRecordsError extends Error {
  constructor (message: string = 'Sem Registro, não há dados para exibir!') {
    super(message)
    this.name = 'ResultWithoutRecordsError'
  }
}
